import { Field } from 'components/marketo-form'
import type { MarketoFormField } from 'components/marketo-form/types'
import s from './style.module.css'

const TwoColumnField = ({ fields }: { fields: MarketoFormField[] }) => {
	return (
		<div className={s.container}>
			<Field field={fields[0]} />
			<Field field={fields[1]} />
		</div>
	)
}

export default TwoColumnField
